import React from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import auth from '../../modules/auth'

import './SessionExpiredModal.scss'

class SessionExpiredModal extends React.Component {
  handleRedirectToLogin = () => {
    auth.removeAuthInfo()
    window.location = '/customer/login'
  }

  render() {
    const { showSessionExpiredModal } = this.props

    return (
      <Modal
        isOpen={showSessionExpiredModal}
        className="session-expired-modal"
        overlayClassName="session-expired-modal__overlay"
        ariaHideApp={false}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
      >
        <div className="session-expired-modal__content">
          <h2 className="session-expired-modal__title">
            セッションの有効期限が切れました
          </h2>
          <p className="session-expired-modal__message">
            ログインの有効期限が切れました。再度ログインしてください。
          </p>
          <button
            className="session-expired-modal__button"
            onClick={this.handleRedirectToLogin}
          >
            ログインページへ
          </button>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  showSessionExpiredModal: state.settings.showSessionExpiredModal
})

export default connect(mapStateToProps)(SessionExpiredModal)



// WEBPACK FOOTER //
// ./src/components/SessionExpiredModal/SessionExpiredModal.js